function normalizeURL(hostname: string) {
  const normalizedUrl = hostname.replaceAll('-', '.');

  return normalizedUrl;
}

export default normalizeURL;
